import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CheckIcon from '@material-ui/icons/Check';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import './styles.css';

function Money(n) {
  var c = 2,
    d = ",",
    t = ".",
    s = n < 0 ? "-" : "",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};


const EstadoPedido = {
  borrador: 'Borrador',
  confirmado: 'Confirmado',
  preparado: 'Preparado',
  entregado: 'Entregado',
  abandonado: 'Abandonado',
  eliminado: 'Eliminado',
}


class ItemDetallePedido extends React.Component {

  /**
 * nombre : titulo del item
 * descripcion: sub titulo, una linea
 * fecha: segunda linea de sub titulo, timestamp
 * monto: cantidad a la derecha, formateada como moneda
 * opciones: lista de opciones desplegables {nombre: string, handler: func}
 * estadoPedido: estado del pedido
 * onClick: click en cualquier lugar del item
 */
  constructor(props) {
    super(props)

    this.state = {
      maxImg: false,
      imageError: false
    }
  }

  handleImageError = () => {
    this.setState({ imageError: true });
  };

  handleClickMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleOnClickImgOpen = () => {
    this.setState({
      maxImg: !this.state.maxImg
    })
  }

  render() {
    //Render no generico
    return !this.props.esGenerico ?
      (
        <div onClick={this.props.onClick} style={{ padding: "5px", margin: "10px", cursor: (this.props.onClick) ? "pointer" : "default" }}>

          {(this.props.imagen !== undefined) && <img alt="" src={this.props.imagen} style={{ objectFit: "cover", backgroundColor: "#000", float: "left", width: "40px", height: "40px", marginRight: "16px", marginBottom: "32px" }} />}
          {(this.props.color !== undefined) && <img alt="" src={this.props.imagenColor} style={{ backgroundColor: this.props.color, float: "left", width: "40px", height: "40px", marginRight: "16px", marginBottom: "32px" }} />}
          <div style={{ fontFamily: "Roboto", fontSize: "16px" }}>{this.props.descripcion}</div>

          <div style={{ fontFamily: "Roboto", fontSize: "14px", fontWeight: "300" }}>{"Talle:" + this.props.talle + " - Código: " + this.props.codigoArticulo}</div>

          <div style={{ fontFamily: "Roboto", fontSize: "14px", fontWeight: "300" }}>{'$' + Money(this.props.precioFinal)}</div>

          <div onClick={(e) => { e.stopPropagation() }} style={{ float: "right", position: "relative", bottom: "50px", borderRadius: "100%" }} className="menuContainer">
            <Button
              aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
              aria-haspopup="true"
              onClick={this.handleClickMenu}
            >
              <MoreVertIcon />
            </Button>

            <Menu
              id="simple-menu"
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl)}
              onClose={this.handleCloseMenu}
            >
              <MenuItem onClick={this.props.onClick}>Ver</MenuItem>
            </Menu>
          </div>



          <div style={{ fontFamily: "Roboto", fontSize: "16px", fontWeight: "300", float: "right", position: "relative", bottom: "40px" }}>{this.props.cantidad}</div>
          {(this.props.listo) &&
            <div style={{
              fontFamily: "Roboto", fontSize: "14px", fontWeight: "300",
              float: "right", position: "relative", bottom: "42px", right: "10px", borderRadius: "10%",
              backgroundColor: "green", color: "white", padding: "3px"
            }}>{"Listo"}</div>
          }

        </div>
      )
      :
      //Render generico
      (

        <div className="itemPedidoContainer">

          {/* Imagen */}
          <div className='cardImgContainer'>
            {this.props.imagen && !this.state.imageError ? (
              <div className='imageArticuloGenerico'>
                <img
                  src={this.props.imagen}
                  alt=''
                  onError={this.handleImageError}
                />
              </div>
            ) : (
              <div className='imageDefault'>
                <div>
                  <img src={require('../../images/logoLogin.png')} alt='' />
                  <div>Producto sin foto</div>
                </div>
              </div>
            )}
          </div>

          {/* Detalles delpedido */}
          <div className="detallesItemContainer">
            <Row className='descripcionItem'>{this.props.descripcion}</Row>
            <Row className='codigoItem'>{this.props.codigoBarra} ({this.props.codigoArticulo})</Row>
            <Row className='alternativa'>{this.props.alternativa}</Row>
          </div>

          <Row className="rowCantidadPrecio">
            <Col xs={6} className="cantidad">{this.props.cantidad}</Col>
            <Col xs={6} className="precio">{'$' + Money(this.props.precioFinal)}</Col>
          </Row>

          {/* Botonera */}
          <div className="containerBtnsPedidoDetalle">
            <Row className="rowBtnsPedidoDetalle">

              {/* BUTTON NO DISPONIBLE */}
              {/*(this.props.btnNoDisponible) && this.props.idPedidoDetalleReemplazado === null && 
              <Col xs className={`${this.props.noDisponible ? 'pedidoDetalleNoDisponible itemPedidoDetalleBtn' : 'itemPedidoDetalleBtn'}`} style={this.props.estadoPedido !== EstadoPedido.confirmado ? {cursor: 'not-allowed'} :{cursor: 'pointer'}}>
                <Tooltip title="No disponible" placement="bottom">
                  <NotInterestedIcon className={`${this.props.noDisponible ? 'pedidoDetalleNoDisponible noDisponibleBtn' : 'noDisponibleBtn'}`} 
                  onClick={(!this.props.listo && !this.props.reemplazado) && (this.props.estadoPedido === EstadoPedido.confirmado) ? () => this.props.handleOnClickMarcarPedidoDetalleNoDisponible(true, this.props.idDetallePedido, this.props.noDisponible) : undefined}/>
                </Tooltip>
              </Col>
              */}

              {/* BUTTON QUITAR */}
              {/* this.props.idPedidoDetalleReemplazado !== null && 
              <Col xs className={`itemPedidoDetalleBtn`} style={this.props.estadoPedido !== EstadoPedido.confirmado ? {cursor: 'not-allowed'} :{cursor: 'pointer'}}>
                <Tooltip title="Quitar" placement="bottom">
                  <DeleteIcon className={`noDisponibleBtn`} 
                  onClick={(this.props.estadoPedido === EstadoPedido.confirmado) ? () => this.props.handleOnClickQuitar(this.props.idPedido, this.props.idDetallePedido, this.props.descripcion) : null}/>
                </Tooltip>
              </Col>
            */}

              {/* BUTTON REEMPLAZAR */}
              {/*this.props.idPedidoDetalleReemplazado === null &&
              <Col xs  onClick={(!this.props.listo && !this.props.noDisponible && !this.props.reemplazado ) && (this.props.estadoPedido === EstadoPedido.confirmado) ?  this.props.onReemplazarClick : undefined} className={`itemPedidoDetalleBtn ${this.props.reemplazado ? 'productoReemplazado' : ''}`} style={this.props.estadoPedido !== EstadoPedido.confirmado ? {cursor: 'not-allowed'} :{cursor: 'pointer'}} > 
                <Tooltip title={`${this.props.reemplazado ? 'Reemplazado':'Reemplazar'}`} placement="bottom" >
                  <div style={{display: 'flex'}}>
                      <SwapHorizIcon />
                  </div>
                </Tooltip>              
              </Col>
            */}

              {/* BUTTON LISTO */}
              {/*(this.props.btnListo) &&
              <Col xs className={`${this.props.listo ? 'pedidoDetalleListo itemPedidoDetalleBtn' : 'itemPedidoDetalleBtn'}`} style={this.props.estadoPedido !== EstadoPedido.confirmado ? {cursor: 'not-allowed'} :{cursor: 'pointer'}}>
                  <Tooltip title="Listo" placement="bottom">
                      <div style={{width:"100%", height:"100%"}}>
                          <CheckIcon  
                          onClick={(!this.props.noDisponible && !this.props.reemplazado) && (this.props.estadoPedido === EstadoPedido.confirmado) ? () => {this.props.marcarPedidoDetalleListo(this.props.idDetallePedido, this.props.listo)} : undefined}/>
                      </div>
                  </Tooltip>
              </Col>
            */}

            </Row>
          </div>
        </div>

      )

  }
}

ItemDetallePedido.propTypes = {
  marcarPedidoDetalleListo: PropTypes.func.isRequired,
  handleOnClickMarcarPedidoDetalleNoDisponible: PropTypes.func.isRequired,
  onReemplazarClick: PropTypes.func.isRequired,
  handleOnClickQuitar: PropTypes.func.isRequired,
}

export default ItemDetallePedido